import Vue from 'vue'
import Vuex from 'vuex'

import {
  reqPortalUserRefresh,
  reqUserAccountList,
  reqPortalAccountSetup,
} from "@services";

// Register Vuex
Vue.use(Vuex)

// Vuex Store
export default new Vuex.Store({
  state: {
    auth: {
      portal_user_id: null,
      account_id: null,
      account_list: [],
      current_account_setup: null,
    }
  },

  getters: {
    async loginStatus(state) {

      if (state.auth.current_account_setup) return true;

      // Retrieve User ID
      const userString = localStorage.getItem('APP_USER_UUID')
      if (!userString) return false

      const userResult = await reqPortalUserRefresh({
        useruuid: userString
      });

      if (!userResult) return false
      if (userResult.status !== "Success") return false;
      if (!userResult.data) return false;

      // Save into State
      state.auth.portal_user_id = userResult.data.portal_user_id;

      // Retrieve User Account List
      const accountListResult = await reqUserAccountList({
        useruuid: userString
      })

      if (accountListResult.status !== "Success") return false;
      if (!accountListResult.data) return false;
      if (accountListResult.data.length === 0) return false;

      // Save into State
      state.auth.account_list = accountListResult.data;

      // Retrieve Current Account
      const accountString = localStorage.getItem('APP_ACCOUNT_UUID');
      if (!accountString) {
        // Save into State
        state.auth.account_id = accountListResult.data[0].account_id;
        state.auth.current_account_setup = accountListResult.data[0];

        // Save into Local Storage
        localStorage.setItem('APP_ACCOUNT_UUID', accountListResult.data[0].account_uuid);

        return true;
      }
      
      else {
        const accountSetupResult = await reqPortalAccountSetup({
          accountuuid: accountString,
          portaluser: state.auth.portal_user_id
        })

        if (!accountSetupResult) return false;
        if (accountSetupResult.status !== 'Success') return false;
        if (!accountSetupResult.data) return false;

        // Save into State
        state.auth.account_id = accountSetupResult.data.account_id;
        state.auth.current_account_setup = accountSetupResult.data;

        return true;
      }

    }
  },

})